// extracted by mini-css-extract-plugin
export default {"container":"JmIdeA","moreButton":"qkpsvz","actionsContainer":"agzzba"};